/**
 * Shipping Notice resource
 *
 * @name ShippingNotice
 * @class
 * @augments TmrResource
 */
export const factory = [
  'ShippingNotice',
  /*@ngInject*/ (TmrResource, Place, Zone) => {
    const referencedProperties = [
      { property: 'originPlace', resource: Place },
      { property: 'destinationPlace', resource: Place },
      { property: 'destinationZone', resource: Zone },
    ]
    const ShippingNotice = TmrResource(
      'ShippingNotice',
      {},
      referencedProperties
    )
    return ShippingNotice
  },
]
